import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { trackCallConversion } from "@/lib/analytics";

export default function CTASection({ title = "Ready for a spotless property?", sub }) {
  return (
    <section className="bg-[var(--oxblood)] text-white" data-testid="cta-section">
      <div className="px-6 md:px-12 max-w-7xl mx-auto py-24 md:py-28 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-white/70 mb-6">Free, no-obligation quote</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-tight max-w-3xl mx-auto">{title}</h2>
          {sub && <p className="mt-6 text-white/80 max-w-xl mx-auto">{sub}</p>}
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote" data-testid="cta-quote-btn" className="bg-white text-[var(--oxblood)] px-10 py-4 tracking-wide hover:bg-white/90 transition-colors">
              Get a Free Quote
            </Link>
            <a href={COMPANY.phoneHref} onClick={trackCallConversion} data-testid="cta-call-btn" className="border border-white/60 text-white px-10 py-4 tracking-wide hover:bg-white hover:text-[var(--oxblood)] transition-all flex items-center justify-center gap-2">
              <Phone className="w-4 h-4" /> Call Now
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
